import { call, put, StrictEffect, takeLatest, select } from 'redux-saga/effects';
import fetchAPI from '@utils/fetchAPI';
import DomainByEnv from '@utils/domainByEnv';
import * as actionTypes from '../actionTypes';
import * as actions from '../actions';
import * as ItinerariesActions from '../../Itineraries/actions';
import { RootState } from '@Redux/detail/store';

declare const window: any;

const detailRoute = `${DomainByEnv()}/detail`;

function* setGroupDetailAsync(
    action: actions.I_GroupDetailAction
): Generator<StrictEffect, any, any> {
    yield put(actions.setGroupDetailSUCCESS({ isLoading: true }));
    const detail = yield call(fetchAPI, {
        url: `${detailRoute}/travelinfojson`,
        req: action.payload,
    });

    // 在載入團或更換團取得新資料後呼叫後端放的 /scripts/shared/gtm.js 裡的gtm相關funtion
    const gtmPara = document.getElementById('gtmPara');
    const seoPara: any = document.getElementById('seoPara');
    gtmPara?.setAttribute('data-GroupID', detail.GroupInfo.GroupID);
    gtmPara?.setAttribute('data-TourBu', detail.GroupInfo.TourBu);
    seoPara?.setAttribute('data-productid', detail.GroupInfo.GroupID);
    seoPara?.setAttribute('data-availability', detail.GroupInfo.Status);
    // 本地開發不觸發 GTM
    if (process.env.NODE_ENV !== 'development') {
        window.writeSEOData();
        window.SetGTM();
    }

    yield put(actions.setGroupDetailSUCCESS({ ...detail, isLoading: false }));
}

function* watchSetGroupDetailAsync() {
    yield takeLatest(actionTypes.SET_GROUPDETAIL, setGroupDetailAsync);
}

function* setGroupAllToursAsync(
    action: actions.I_GroupAllToursAction
): Generator<StrictEffect, any, any> {
    const tours = yield call(fetchAPI, {
        url: `${detailRoute}/tourinfojson`,
        req: action.payload,
    });

    yield put(actions.setGroupAllToursSUCCESS(tours));
}

function* watchsetGroupAllToursAsync() {
    yield takeLatest(actionTypes.SET_GROUPALLTOURS, setGroupAllToursAsync);
}

function getGroupTourID(state: RootState) {
    return state.groupReducer.GroupInfo.TourID;
}

function getTravelType(state: RootState) {
    return state.groupReducer.GroupInfo.TravelType;
}

function getCurrentTourID(state: RootState) {
    return state.groupReducer.currentTourID;
}

function getTourBu(state: RootState) {
    return state.groupReducer.GroupInfo.TourSource;
}

function* setGroupAllCalendarAsync(
    action: actions.I_GroupAllCalendarAction
): Generator<StrictEffect, any, any> {
    const groups = yield call(fetchAPI, {
        url: `${detailRoute}/groupcalendarjson`,
        req: action.payload,
    });
    yield put(actions.setGroupAllCalendarSUCCESS(groups));

    const groupTourID = yield select(getGroupTourID);
    const TravelType = yield select(getTravelType);
    const currentTourID = yield select(getCurrentTourID);
    const TourSource = yield select(getTourBu);

    /**
     * 如果
     * 1. 選擇行程不是全部 (currentTourID 不為空值)
     * 2. 現在團的 TourID (GroupInfo.TourID) 跟現在的選擇行程 (currentTourID) 不一樣
     * -> 將現在團號更換成第一筆
     */
    if (groups?.length > 0 && currentTourID && groupTourID !== currentTourID) {
        console.log('groups =>', groups);

        yield put(
            actions.setGroupDetail({
                GroupID: groups[0].ID,
                TourSource,
            })
        );

        yield put(
            ItinerariesActions.setItineraries({
                TourID: groups[0].TourID,
                GroupID: groups[0].ID,
                IsPreview: groups[0].IsPreview,
                TravelType: TravelType,
                TourSource,
            })
        );
    }
}

function* watchSetGroupAllCalendarAsync() {
    yield takeLatest(actionTypes.SET_GROUPALLCALENDAR, setGroupAllCalendarAsync);
}

function* setTodayMoreAsync(action: actions.I_TodayMoreAction): Generator<StrictEffect, any, any> {
    const todayMore = yield call(fetchAPI, {
        url: `${detailRoute}/packageinfojson`,
        req: action.payload,
    });

    yield put(actions.setTodayMoreSUCCESS(todayMore));
}

function* watchSetTodayMoreAsync() {
    yield takeLatest(actionTypes.SET_TODAYMORE, setTodayMoreAsync);
}

function* setPricesInfoAsync(
    action: actions.I_PricesInfoAction
): Generator<StrictEffect, any, any> {
    const price = yield call(fetchAPI, {
        url: `${detailRoute}/priceinfojson`,
        req: action.payload,
    });

    yield put(actions.setPricesInfoSUCCESS(price));
}

function* watchSetPricesInfoAsync() {
    yield takeLatest(actionTypes.SET_PRICESINFO, setPricesInfoAsync);
}

function* setSkiAsync(action: actions.I_SkiAction): Generator<StrictEffect, any, any> {
    const ski = yield call(fetchAPI, {
        url: `${detailRoute}/skisituationinfojson`,
        req: action.payload,
    });

    yield put(actions.setSkiSUCCESS(ski));
}

function* watchSetSkiAsync() {
    yield takeLatest(actionTypes.SET_SKI, setSkiAsync);
}

function* setStationInfoAsync(
    action: actions.I_StationInfoAction
): Generator<StrictEffect, any, any> {
    const station = yield call(fetchAPI, {
        url: `${detailRoute}/stationinfojson`,
        req: action.payload,
    });

    yield put(actions.setStationInfoSUCCESS(station));
}

function* watchSetStationInfoAsync() {
    yield takeLatest(actionTypes.SET_STATIONINFO, setStationInfoAsync);
}

function* setFlightInfoAsync(
    action: actions.I_FlightInfoAction
): Generator<StrictEffect, any, any> {
    const flightInfo = yield call(fetchAPI, {
        url: `${detailRoute}/packageinfojson`,
        req: action.payload,
    });

    yield put(actions.setFlightInfoSUCCESS(flightInfo));
}

function* watchSetFlightInfoAsync() {
    yield takeLatest(actionTypes.SET_FLIGHTINFO, setFlightInfoAsync);
}

function* setCallJsonAsync(action: actions.I_CallJsonAction): Generator<StrictEffect, any, any> {
    const callJson = yield call(fetchAPI, {
        url: `${detailRoute}/calljson`,
        req: action.payload,
    });

    yield put(actions.setCallJsonSUCCESS({ ...callJson, isCompleted: true }));
}

function* watchSetCallJsonAsync() {
    yield takeLatest(actionTypes.SET_CALLJSON, setCallJsonAsync);
}

export default [
    watchSetGroupDetailAsync(),
    watchSetGroupAllCalendarAsync(),
    watchsetGroupAllToursAsync(),
    watchSetStationInfoAsync(),
    watchSetPricesInfoAsync(),
    watchSetTodayMoreAsync(),
    watchSetSkiAsync(),
    watchSetFlightInfoAsync(),
    watchSetCallJsonAsync(),
];
